export default "__VITE_ASSET__DicEC_R5__"